import React, {Component} from 'react';
import {connect} from 'react-redux';
import Loader from 'components/atoms/loaders/loader';
import {GameComponent} from './game';
import AllGamesChecking from './all-games-checking';
import Action from 'actions';
import {sortByProperty} from 'helpers/sorters';

class FilterByGames extends Component {
    constructor(props) {
        super(props);
        this.state = {active: false};
    }

    onClick() {
        this.setState({active: !this.state.active});
    }

    clickOnGame(gameTeams) {
        const {playersFilter} = this.props;

        let teams = playersFilter.games.slice(),
            isTeamFound = teams.some((team) => inArray(team, gameTeams));

        if (isTeamFound) {
            teams = teams.filter((team) => !inArray(team, gameTeams));
        } else {
            teams = teams.concat(gameTeams);
        }

        this.props.dispatch(Action.set('GamesFilter', teams));
    }

    clickOnTeam(team) {
        const {playersFilter} = this.props;

        const teams = playersFilter.games.slice();
        const index = teams.indexOf(team);

        if (index === -1) {
            teams.push(team);
        } else {
            teams.splice(index, 1);
        }

        this.props.dispatch(Action.set('GamesFilter', teams));
    }

    getGamesFilterView() {
        const {games} = this.props;

        if (games.isLoading()) {
            return <Loader />;
        } else if (!games.hasGames()) {
            return <div className="not-found-text">Games were not found.</div>;
        }

        const sortedGames = games.getAllAsArr().sort(sortByProperty('gameTimestamp'));

        return sortedGames.map((game, index) => {
            return (
                <GameComponent
                    key={index}
                    game={game}
                    clickOnGameCallback={::this.clickOnGame}
                    clickOnTeamCallback={::this.clickOnTeam}
                />
            );
        });
    }

    getAllGamesCheckingView() {
        const {games} = this.props;

        if (games.hasMoreThanOneGame()) {
            return <AllGamesChecking />;
        }

        return null;
    }

    render() {
        const {sportConfig} = this.props;

        return (
            <div
                className={`game-filter-block sport-${sportConfig.getSport()} ${this.state.active ? 'close-filter' : ''}`}
            >
                <h2>
                    <span onClick={::this.onClick} className="games-opener">
                        Games Filter
                    </span>
                </h2>
                <div className="game-filter-wrap">
                    {this.getAllGamesCheckingView()}
                    {this.getGamesFilterView()}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {games, filters} = state.playersData;
    const {sportConfig} = state;

    return {
        games,
        sportConfig,
        playersFilter: filters,
    };
}

const FilterByGamesComponent = connect(mapStatesToProps)(FilterByGames);

export {FilterByGamesComponent};
